/**
 * The venue detail page's tab bar (BON-159).
 *
 * A pill group rather than underlined tabs, matching the rest of the dashboards
 * chrome. Extracted from `VenueDetailPage` — one component per file.
 */
import { TABS, type Tab } from './venue-tabs';

export interface VenueTabBarProps {
  tab: Tab;
  setTab: (t: Tab) => void;
}

export function VenueTabBar({ tab, setTab }: VenueTabBarProps) {
  return (
    <nav
      style={{
        display: 'flex',
        gap: 2,
        alignSelf: 'flex-start',
        background: 'var(--nb-surface)',
        border: '1px solid var(--nb-border)',
        borderRadius: 999,
        padding: 3,
      }}
    >
      {TABS.map((t) => (
        <button
          key={t}
          type="button"
          onClick={() => setTab(t)}
          style={{
            padding: '5px 14px',
            borderRadius: 999,
            fontSize: 12.5,
            fontWeight: 600,
            border: 0,
            cursor: 'pointer',
            color: tab === t ? 'var(--nb-bark-dark)' : 'var(--nb-muted)',
            background: tab === t ? 'var(--nb-bg)' : 'transparent',
            boxShadow: tab === t ? '0 1px 2px rgba(0,0,0,.06)' : 'none',
          }}
        >
          {t}
        </button>
      ))}
    </nav>
  );
}
